(function () {
  var style = document.createElement('style');
  style.textContent =
    '.cp-bespaard-badge{display:flex;align-items:center;gap:.6rem;background:#e8f5e1;border-radius:.6rem;padding:.6rem 1rem;color:#3c840c;font-size:1.35rem;font-weight:600;margin-bottom:.8rem}' +
    '.cp-bespaard-badge svg{flex-shrink:0}';
  document.head.appendChild(style);

  function getBadge() {
    var b = document.getElementById('cp-bespaard-badge');
    if (b) return b;
    var summary = document.getElementById('cp-summary-block');
    if (!summary) return null;
    b = document.createElement('div');
    b.id = 'cp-bespaard-badge';
    b.className = 'cp-bespaard-badge';
    b.style.display = 'none';
    b.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16" aria-hidden="true">' +
      '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>' +
      '<line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
      '<span id="cp-bespaard-text"></span>';
    summary.insertBefore(b, summary.firstChild);
    return b;
  }

  function updateBadge(totalDiscount, originalTotal) {
    var badge = getBadge();
    if (!badge) return;
    var text = document.getElementById('cp-bespaard-text');
    if (totalDiscount > 0 && originalTotal > 0) {
      var pct = Math.round(totalDiscount / originalTotal * 100);
      if (text) text.textContent = 'Ontvangen korting ' + pct + '%';
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCart = url.indexOf('/cart.js') !== -1 || url.indexOf('/cart/change.js') !== -1;
    var p = _fetch.apply(this, arguments);
    if (isCart) {
      p.then(function (res) {
        res.clone().json().then(function (cart) {
          if (typeof cart.total_discount === 'number') {
            updateBadge(cart.total_discount, cart.original_total_price || 0);
          }
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };
})();
